import { FormCard, FormItem, TextArea } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import LastUpdateBox from 'components/carePlans/LastUpdateBox'
import { lastUpdateCarerFromUpdatedByData } from 'components/carePlans/lastUpdateCarerFromUpdatedByData'
import type { ResidentItemExtended } from 'hooks/useResident'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { SupDatePicker } from '../../../styledComponents'
import { dateFormat } from '../../../utils/utils'

export const AccessInformationFormCard = ({
  resident,
  testId
}: {
  resident?: ResidentItemExtended
  testId?: string
} = {}) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const updatedAt = resident?.accessInformation?.updatedAt
  const updatedByCarer = lastUpdateCarerFromUpdatedByData(
    resident?.accessInformation?.updatedByData
  )

  return (
    <FormCard
      title={t(supConstants.ACCESS_INFORMATION)}
      testId={
        testId ? `${testId}-access-information-card` : 'access-information-card'
      }
    >
      <FormItem
        label={<Text>{t(supConstants.SPECIAL_ACCESS_REQUIREMENTS)}</Text>}
        name={['accessInformation', 'specialAccessRequirements']}
      >
        <TextArea autoSize={{ minRows: 3 }} />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.DATE_OF_OBSERVATION)}</Text>}
        name={['accessInformation', 'dateOfObservation']}
      >
        <SupDatePicker placeholder="" format={dateFormat} />
      </FormItem>
      {updatedAt && (
        <LastUpdateBox
          date={updatedAt}
          carer={updatedByCarer}
          noDateText=""
          style={{ paddingInline: 0 }}
        />
      )}
    </FormCard>
  )
}
